import script from "./ClientDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ClientDetails.vue?vue&type=style&index=0&id=1d11d3cb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d11d3cb"]])

export default __exports__